/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { yupResolver } from "@hookform/resolvers/yup";
import { makeStyles } from "@material-ui/core/styles";
import * as yup from "yup";
import { REQUIRED_MESSAGE } from "../../constants";
import { Controller, useForm } from "react-hook-form";
import { FormControl, FormHelperText, Grid, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Utils from "../../utils/utils";
import { useStateValue } from "../../context/store";
import { saveLactationInformationAsync } from "../../actions/licence-motherhood-actions";
import moment from "moment";

export const styles = makeStyles((theme) => ({
  form: {
    width: "auto",
    marginTop: "0px",
    marginRight: "15px",
    marginLeft: "15px",
  },
  formControl: {
    padding: "8px",
    maxHeight: "35px",
    maxWidth: "331px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: "35px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  notes: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
  field: {
    borderRadius: "8px",
    height: "35px",
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

const LactationCalculationModal = ({
  handleClose,
  open,
  licenceId,
  setMessage,
  setShowMessage,
  estimatedDueDate,
  licenseEndDateValue,
  setHasEdition,
  hasEdition
}) => {
  const classes = styles();
  const [dateError, setDateError] = useState(false);
  const [{ }, dispatch] = useStateValue();
  const [dateErrorMessage, setDateErrorMessage] = useState("");

  var currentDate = new Date();

  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );
  const [maxDate, setMaxDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  const onChangeDate = (value) => {
    calculateLactationFinishDate(value);
  };

  const calculateLactationFinishDate = (value) => {
    let lactancyFinishDate = moment(value).add(6, 'months');
    //const result = moment(lactancyFinishDate).diff(value, 'weeks');
    //lactancyFinishDate = moment(lactancyFinishDate).subtract(result, 'days');
    setMaxDate(lactancyFinishDate);
    setValue("licenseEndDate", lactancyFinishDate);
  }

  const schema = yup.object().shape({
    licenseStartDate: yup
      .date()
      .required(REQUIRED_MESSAGE)
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (licenseStartDate) => licenseStartDate && licenseStartDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .required(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    licenseEndDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .nullable(true)
      .notRequired(),
    observations: yup
      .string()
      .notRequired()
      .max(600, "Ingrese máximo 600 caracteres"),
  });

  const defaultValues = {
    licenseStartDate: estimatedDueDate,
    observations: null,
    licenseEndDate: licenseEndDateValue,
  };

  const { register, handleSubmit, control, errors, getValues, setValue } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const onSubmit = async (data) => {
    const format1 = "YYYY-MM-DD HH:mm:ss";
    const response = await saveLactationInformationAsync({
      lactationStartDate: moment(data.licenseStartDate).format(format1),
      observation: data.observations,
      lactationEndDate: moment(data.licenseEndDate).format(format1),
      maternityLicenceId: licenceId
    }, dispatch);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setShowMessage(true);
      setMessage({
        description: `El calculo de lactancia se ha agregado de forma exitosa.`,
        textButtonSubmit: "Volver",
        handleClick: () => handleClose(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      setHasEdition(!hasEdition);
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setShowMessage(true);
      setMessage({
        description: `El registro no ha sido guardado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setShowMessage(true);
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  }

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16 },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "black" }}>
          <div style={{ textAlign: "center" }}>
            <p>Cálculo de lactancia</p>
          </div>
        </DialogTitle>
        <DialogContent >
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="off"
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        fullWidth
                        InputProps={{ readOnly: true }}
                        inputVariant="outlined"
                        variant="inline"
                        format="dd/MM/yyyy"
                        dateFormat="DD/MM/YYYY"
                        label="Desde *"
                        InputLabelProps={{ shrink: true }}
                        onAccept={onChangeDate}
                        error={
                          !!errors.hasOwnProperty("licenseStartDate") &&
                          errors["licenseStartDate"].message
                        }
                        helperText={
                          errors.hasOwnProperty("licenseStartDate") &&
                          errors["licenseStartDate"].message
                        }
                        minDate="01.01.2020"
                      />
                    }
                    control={control}
                    name="licenseStartDate"
                    defaultValue={estimatedDueDate}
                    placeholder="Desde"
                    size="small"
                    
                  />
                </MuiPickersUtilsProvider>
                <FormHelperText style={{ color: "#f44336" }}>
                  {dateError && dateErrorMessage}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        fullWidth
                        InputProps={{ readOnly: true }}
                        inputVariant="outlined"
                        variant="inline"
                        format="dd/MM/yyyy"
                        dateFormat="DD/MM/YYYY"
                        label="Hasta *"
                        readOnly
                        InputLabelProps={{ shrink: true }}
                        error={
                          !!errors.hasOwnProperty("licenseEndDate") &&
                          errors["licenseEndDate"].message
                        }
                        helperText={
                          errors.hasOwnProperty("licenseEndDate") &&
                          errors["licenseEndDate"].message
                        }
                        minDate={maxDate}
                        maxDate={maxDate}
                      />
                    }
                    control={control}
                    name="licenseEndDate"
                    defaultValue={licenseEndDateValue}
                    placeholder="Hasta"
                    size="small"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    defaultValue=""
                    inputRef={register}
                    variant="outlined"
                    type="text"
                    autoComplete="off"
                    multiline
                    rows={4}
                    rowsMax={4}
                    inputProps={{ maxLength: 600 }}
                    error={
                      !!errors.hasOwnProperty("observations") &&
                      errors["observations"].message
                    }
                    helperText={
                      errors.hasOwnProperty("observations") &&
                      errors["observations"].message
                    }
                    label="Observaciones"
                    name="observations"
                    size="small"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12} style={{ textAlign: "center", paddingTop: "10px", paddingBottom: "20px" }}>
                <Button
                  variant="contained"
                  className={classes.buttonSearch}
                  type="submit"
                  onClick={handleClose}
                >
                  Cancelar
                </Button>
                &nbsp;&nbsp;
                <Button
                  variant="contained"
                  className={classes.buttonSearch}
                  type="submit"
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>

      </Dialog>
    </div>
  );
};
export default LactationCalculationModal;
